import { render, staticRenderFns } from "./PendingInvoicesList.vue?vue&type=template&id=2b7a931e&"
import script from "./PendingInvoicesList.vue?vue&type=script&lang=js&"
export * from "./PendingInvoicesList.vue?vue&type=script&lang=js&"
import style0 from "./PendingInvoicesList.vue?vue&type=style&index=0&id=2b7a931e&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports